import React from "react";
import callAPI from "../service/callAPI";
import { hide, popup, setModalData } from "./deleteModal";

export default function DeleteButton(props: { url: string; id: string }) {
	const { url, id } = props;
	const buttons = (
		<React.Fragment>
			<button type="button" className="btn btn-secondary" data-dismiss="modal">
				Bỏ qua
			</button>
			<button
				type="button"
				className="btn btn-danger mr-2"
				onClick={() =>
					callAPI(url, { method: "DELETE" })
						.then(() => {
							hide();
							window.location.reload();
						})
						.catch((e) => alert(`Lỗi xóa bài|${e.toString()}`))
				}
			>
				Xóa
			</button>
		</React.Fragment>
	);
	return (
		<button
			className="btn btn-danger btn-circle btn-sm "
			title="Delete"
			onClick={() => {
				setModalData({
					title: "Thông Báo",
					message: (
						<p>
							Bạn có chắc muốn xóa <b>{id}</b>?
						</p>
					),
					buttons
				});
				popup();
			}}
		>
			<i className="fas fa-minus-circle"></i>
		</button>
	);
}
